import axios from "axios";
import filter from 'lodash/filter';
import findLodash from 'lodash/find';
import assign from 'lodash/assign';
// import _ from "lodash"

const state = {
    first_loading: true,
    loading_preview: false,
    loading_general: false,
    loading_live: false,
    loading_detail: false,
    preview: [],
    count_live: [],
    preview_live: [],
    live_mode: 'preview',
    tournaments_active: [],
    events_detail: [],
    events_detail_active: [],
    events_live_detail: [],
    events_live_detail_active: [],
    count_next_events: [],
    count_events_day: [],
    preview_next_events: [],
    preview_events_day: [],
    preview_events_best_played: [],
    count_events_best_played: [],
    live_sport_selected: {},
    cashout: {},
    daySkip: 0,
    dayLimit: 5,
    event_statscore: false,
    prematch_statscore: false,
    odds_type: 'decimal',
    supportedOddsFormats: [],
    configuredGroupsMarkets: [],
    marketsGroupsIdActive: [],
    marketsIdActive: [],
    previewTabsSelectedForTournament: [],
    nextEventModuleSelected: 'widget',// widget - normal
    marketsGroupsDetailPrematch: [],
    marketsGroupsDetailLive: [],
    featuredTournaments: [],
    viewLiveMatchTracker: true,
    previewV3: [],
    hideBestPlayedWidget: false,
    bestPlayedEvents: [],
    bestPlayedSports: [],
    bestPlayedPaging: {
        total: 0,
        page: 1,
        pages: 1
    },
    loadingBestPlayed: false,
    loading: false

};

const getters = {


    getLoadingPreview: state => {
        return state.loading_preview;
    },
    getFirstLoading: state => {
        return state.first_loading;
    },
    getLoadingGeneral: state => {
        return state.loading_general;
    },
    getLiveSportSelected: state => {
        return state.live_sport_selected;
    },
    getLoadingLive: state => {
        return state.loading_live;
    },
    getLiveMode: state => {
        return state.live_mode;
    },
    getLoadingDetail: state => {
        return state.loading_detail;
    },
    getPreview: state => {
        return state.preview;
    },
    getPreviewLive: state => {
        return state.preview_live;
    },
    getCountLive: state => {
        return state.count_live;
    },
    getTournamentsActive: state => {
        return state.tournaments_active;
    },
    getEventsDetail: state => {
        return state.events_detail;
    },
    getEventsLiveDetail: state => {
        return state.events_live_detail;
    },
    getEventsLiveDetailActive: state => {
        return state.events_live_detail_active;
    },
    getEventsDetailActive: state => {
        return state.events_detail_active;
    },

    getCountNextEvents: state => {
        return state.count_next_events
    },

    getEventStatscore: state => {
        return state.event_statscore
    },
    getConfiguredGroupsMarkets: state => {
        return state.configuredGroupsMarkets;
    },
    getMarketsGroupsIdActive: state => {
        return state.marketsGroupsIdActive;
    },
    getMarketsIdActive: state => {
        return state.marketsIdActive;
    },

    getOddsType: state => {
        return state.odds_type
    },
    getPreviewTabsSelectedForTournament: state => {
        return state.previewTabsSelectedForTournament;
    },
    getNextEventModuleSelected: state => {
        return state.nextEventModuleSelected
    },
    getMarketsGroupsDetailPrematch: state => {
        return state.marketsGroupsDetailPrematch
    },
    getMarketsGroupsDetailLive: state => {
        return state.marketsGroupsDetailLive
    },
    getFeaturedTournaments: state => {
        return state.featuredTournaments
    },
    getViewLiveMatchTracker: state => {
        return state.viewLiveMatchTracker
    },
    getHideBestPlayedWidget: state => {
        return state.hideBestPlayedWidget
    },

    getBestPlayedEvents: state => state.bestPlayedEvents,
    getBestPlayedSports: state => state.bestPlayedSports,
    // Getter fondamentale per la vista
    getBestPlayedPaging: state => state.bestPlayedPaging,
    isLoadingBestPlayed: state => state.loadingBestPlayed
};

const actions = {

    async getEventIdLiveTracker(context, payload) {
        let matchId = payload.matchId;
        let sport = payload.sport;
        const url = `${context.rootGetters['settings/getUrlApi']}/sports/livematch-tracker/sport/${sport}/event/` + matchId;
        return await axios.get(url,
            {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}});
    },

    //todo evaluate to deprecate me what is this ???
    async settlementOddsLive(context, payload) {
        // console.log('payload prova', payload)

        var event = payload

        var code = event.code

        if (context.rootGetters['user/getDetailMyBets']) {
            var clone = JSON.parse(JSON.stringify(context.rootGetters['user/getDetailMyBets']))

            if (clone.code == code) {
                clone = event
                context.commit('user/SET_DETAIL_MY_BETS', clone, {root: true})
            }
        }

        if (context.rootGetters['user/getMyBets']) {
            var clone = JSON.parse(JSON.stringify(context.rootGetters['user/getMyBets']))
            var check = findLodash(clone, {'code': code})

            if (check) {
                assign(check, event)
                context.commit('user/SET_MY_BETS', clone, {root: true})
            }
        }

        if (context.rootGetters['user/getMyBetsInProgress']) {
            var clone = JSON.parse(JSON.stringify(context.rootGetters['user/getMyBetsInProgress']))
            var check = findLodash(clone, {'code': code})

            if (check) {
                assign(check, event)
                context.commit('user/SET_MY_BETS_IN_PROGRESS', clone, {root: true})
            }
        }
        if (context.rootGetters['user/getMyBetsAll']) {
            var clone = JSON.parse(JSON.stringify(context.rootGetters['user/getMyBetsAll']))
            var check = findLodash(clone, {'code': code})

            if (check) {
                assign(check, event)
                context.commit('user/SET_MY_BETS_ALL', clone, {root: true})
            }
        }
        if (context.rootGetters['user/getMyBetsInProgressAll']) {
            var clone = JSON.parse(JSON.stringify(context.rootGetters['user/getMyBetsInProgressAll']))
            var check = findLodash(clone, {'code': code})

            if (check) {
                assign(check, event)
                context.commit('user/SET_MY_BETS_ALL_IN_PROGRESS', clone, {root: true})
            }
        }

    },

    async fetchLiveScores(context, payload) {
        const {eventIds} = payload;
        return await axios.post(
            `${context.rootGetters['settings/getUrlApi']}/v3/live-scores`,
            {provider: 'lsport', eventIds},
            {headers: {Authorization: `Bearer ${context.rootGetters['settings/getToken']}`}}
        ).then(res => res.data);
    },

    // Lineups and per-player stats of one event (teams[].players[].stats).
    async fetchPlayerStats(context, payload) {
        const { eventId } = payload;
        return await axios.post(
            `${context.rootGetters['settings/getUrlApi']}/v3/live-scores/player-stats`,
            { eventId: String(eventId) },
            { headers: { Authorization: `Bearer ${context.rootGetters['settings/getToken']}` } }
        ).then(res => res.data);
    },


    async fetchSettingsGroupsMarketV3(context, payload) {


        //console.log('entered in fetchSettingsGroupsMarket')

        let sport_id = payload.sport;
        if (sport_id == null) {  //todo check this before close the feature
            // console.log('sport_id is null')
            // console.log('returning')
            return;
        }

        const groupMarketObj = state.configuredGroupsMarkets.some(settingGroupMarket => settingGroupMarket.sport_id === payload.sport && settingGroupMarket.sportId === payload.sportId && settingGroupMarket.categoryId === payload.categoryId && settingGroupMarket.tournamentId === payload.tournamentId);

        if (groupMarketObj == false) { // if i have not this configuration stored in the store, call rocky api
            // NOTE:   am not calling again rocky api for get data that i have
            // call rocky api for take setting group for this sport category (example Football, BasketBall...)

            // console.log('[DEBUG] axios call to /settings/sport/groupoddsmarkets/lists')
            await axios.post(`${context.rootGetters['settings/getUrlApi']}/settings/sport/groupoddsmarkets/lists-v4`, {
                "section": "sport",
                // 'sport_id': payload.sport,
                "lang": payload.lang,
                "product_id": payload.product_id,
                "platform": payload.platform,
                "type": payload.type,
                'sportId': payload.sportId,
                'tournamentId': payload.tournamentId,
                'categoryId': payload.categoryId
            }, {'headers': {'Authorization': `Bearer ${context.rootGetters['settings/getToken']}`}})
                .then(async (res) => {

                    let data_to_save = [];

                    if (res.data != null) {
                        data_to_save = res.data
                        await context.dispatch('marketview/updateMarketsMapSizeButtonsDetailPrematch', res.data.mapSizeButtons, {root: true});
                    }
                    context.commit('addGroupsMarketsObject', {
                        sport_id: payload.sport,
                        sportId: payload.sportId,
                        categoryId: payload.categoryId,
                        tournamentId: payload.tournamentId,
                        data: data_to_save
                    })

                }).catch((error) => {
                    console.error('[odds/fetchSettingsGroupsMarket]', error);
                });
        }
    },

    async removeFromTournamentActive(context, payload) {

        const tournamentsActive = filter(state.tournaments_active, function (tournamentActive) {
            return tournamentActive != payload
        });
        context.commit('SET_TOURNAMENTS_ACTIVE', tournamentsActive);
    },

    async setLoadingPreview(context, payload) {
        context.commit('SET_LOADING_PREVIEW', payload.status)
    },
    async setLoadingGeneral(context, payload) {
        context.commit('SET_LOADING_GENERAL', payload.status)
    },
    async setFirstLoading(context, payload) {
        context.commit('SET_FIRST_LOADING', payload.status)
    },
    async setLoadingLive(context, payload) {
        context.commit('SET_LOADING_LIVE', payload.status)
    },
    async setLiveMode(context, payload) {
        if (payload.mode == 'preview') {
            context.commit('detailLive/SET_EVENT_LIVE_DETAIL', [], { root: true })
            context.commit('detailLive/SET_EVENTS_LIVE_DETAIL_ACTIVE', [], { root: true })
        }

        context.commit('SET_LIVE_MODE', payload.mode)
    },
    async setLoadingDetail(context, payload) {
        context.commit('SET_LOADING_DETAIL', payload.status)
    },
    async setLiveSportSelected(context, payload) {
        context.commit('SET_LIVE_SPORT_SELECTED', payload.data)
    },

    async setEventStatscore(context, payload) {
        context.commit('SET_EVENT_STATSCORE', payload)
        return
    },
    async setPrematchEventStatscore(context, payload) {
        context.commit('SET_PREMATCH_EVENT_STATSCORE', payload)
        return
    },

    async setViewLiveMatchTracker(context, payload) {
        context.commit('SET_VIEW_LIVE_MATCH_TRACKER', payload)
    },

    async showAlertEventNotAvailable(context, source) {
        context.dispatch('settings/setSnackbar', true, {root: true})
        context.dispatch('settings/setSnackbarText', 'eventsNoLongerAvailable', {root: true})
        context.dispatch('odds/removeFromTournamentActive', source, {root: true})
        setTimeout(() => context.dispatch('settings/setSnackbar', false, {root: true}), 2000);
    },
};

const mutations = {

    SET_PREVIEW(state, payload) {
        state.preview = payload;
    },
    SET_TOURNAMENTS_ACTIVE(state, payload) {
        state.tournaments_active = payload;
    },
    SET_LOADING_LIVE(state, payload) {
        state.loading_live = payload
    },
    SET_LOADING_PREVIEW(state, payload) {
        state.loading_preview = payload
    },

    SET_LIVE_MODE(state, payload) {
        state.live_mode = payload
    },
    SET_LIVE_SPORT_SELECTED(state, payload) {
        state.live_sport_selected = payload
    },
    addGroupsMarketsObject(state, payload) {
        state.configuredGroupsMarkets.push(payload);
    },
    setMarketsGroupsIdActive(state, payload) {
        state.marketsGroupsIdActive = payload;
    },
    addMarketsGroupIdActive(state, payload) {
        state.marketsGroupsIdActive.push(payload);
    },
    replaceMarketGroupIdActive(state, payload) {
        const objIndex = state.marketsGroupsIdActive.findIndex((marketGroupInfo => marketGroupInfo.tournamentId == payload.tournamentId));

        if (objIndex != -1) {
            // ✅ CORRETTO (Reattivo): Rimuovi 1 elemento a quell'indice e inserisci il nuovo
            state.marketsGroupsIdActive.splice(objIndex, 1, payload);
        }
    },

    SET_ODDS_TYPE(state, payload) {
        state.odds_type = payload;
    },

    SET_SUPPORTED_ODDS(state, payload) {
        state.supportedOddsFormats = payload;
    },
    SET_PREVIEW_TYPE_VIEW(state, payload) {
        const marketIndex = state.marketsGroupsIdActive.findIndex((marketGroupActive) => {
            return marketGroupActive.tournamentId == payload.tournamentId
        })

        if (marketIndex != -1) {
            state.marketsGroupsIdActive[marketIndex].typeView = payload.typeView;
        }
    },
    SET_SIZE_ODD_BUTTON(state, payload) {
        const marketIndex = state.marketsGroupsIdActive.findIndex((marketGroupActive) => {
            return marketGroupActive.tournamentId == payload.tournamentId
        })

        if (marketIndex != -1) {
            state.marketsGroupsIdActive[marketIndex].sizeOddsButtons = payload.sizeOddsButtons
        }
    },

    FIND_AND_UPDATE_PREVIEW_TABS_ACTIVE_FOR_TOURNAMENT(state, payload) {

        const indexOfTabActiveForThisTournament = state.previewTabsSelectedForTournament.findIndex((tab_active => tab_active.tournamentId == payload.tournamentId));

        if (indexOfTabActiveForThisTournament == -1) {
            state.previewTabsSelectedForTournament.push({
                tournamentId: payload.tournamentId,
                index: payload.index,
                marketId: payload.marketId
            })
        } else {
            state.previewTabsSelectedForTournament[indexOfTabActiveForThisTournament] = {
                tournamentId: payload.tournamentId,
                index: payload.index,
                marketId: payload.marketId
            }
        }
    },

    SET_MARKETS_GROUPS_DETAIL_LIVE(state, payload) {
        state.marketsGroupsDetailLive = payload;
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
